import _ from "lodash";
import { SessionExtra } from "../../store/Session/SessionModel";
import { formatTargetDistance } from "../../store/Session/helper/UnitConversions";
interface Props {
	sessionData: SessionExtra;
}
const BestTarget = ({ sessionData }: Props) => {
	const { drillTargets, measuringSystem }: any = sessionData;
	const bestTargetData = _.orderBy(drillTargets, ["targetQuality"], ["desc"]);
	const filteredBestTargetData = bestTargetData.filter(
		(target) =>
			target.targetQuality !== null && target.targetQuality !== undefined,
	);
	return (
		<div className="combine-item">
			<div className="combine-item-header">Best Target</div>
			<div className="combine-item-score target">
				{filteredBestTargetData[0]?.targetQuality?.toFixed() ?? "---"}
			</div>
			<div className="combine-item-footer">
				<span>
					<img width={20} src="/img/combine/fs_target.png" alt="" />
				</span>
				<span>
					{formatTargetDistance(
						filteredBestTargetData[0]?.distance?.maxDistance
							? 0
							: filteredBestTargetData[0]?.distance?.distance,
						measuringSystem,
					)}
				</span>
			</div>
		</div>
	);
};
export default BestTarget;
